<script setup>
const route = useRoute();
const router = useRouter();

const loading = ref();

const load = () => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
  }, 3000);
};

definePage({
  meta: {
    layout: "default",
  },
});
const pageTitle = "Data Mall";

const pageMethod = "Update";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/mall",
  },
  {
    title: pageMethod,
    to: null,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <MallForm v-model:pageMethod="pageMethod" v-model:pageTitle="pageTitle" />
</template>
